import { Container } from "./bottomreviewspanel.components";

const BottomReviewsPanel: React.FC = () => {
  return <Container />;
};

export default BottomReviewsPanel;
